/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InitialWaterlevel } from "./InitialWaterlevel";
import {
  InitialWaterlevelFromJSON,
  InitialWaterlevelFromJSONTyped,
  InitialWaterlevelToJSON,
  InitialWaterlevelToJSONTyped,
} from "./InitialWaterlevel";

/**
 *
 * @export
 * @interface PaginatedInitialWaterlevelList
 */
export interface PaginatedInitialWaterlevelList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<InitialWaterlevel>;
}

/**
 * Check if a given object implements the PaginatedInitialWaterlevelList interface.
 */
export function instanceOfPaginatedInitialWaterlevelList(
  value: object
): value is PaginatedInitialWaterlevelList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedInitialWaterlevelListFromJSON(json: any): PaginatedInitialWaterlevelList {
  return PaginatedInitialWaterlevelListFromJSONTyped(json, false);
}

export function PaginatedInitialWaterlevelListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedInitialWaterlevelList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(InitialWaterlevelFromJSON),
  };
}

export function PaginatedInitialWaterlevelListToJSON(json: any): PaginatedInitialWaterlevelList {
  return PaginatedInitialWaterlevelListToJSONTyped(json, false);
}

export function PaginatedInitialWaterlevelListToJSONTyped(
  value?: PaginatedInitialWaterlevelList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(InitialWaterlevelToJSON),
  };
}
